@switch (specificTemplateName) {
  @case (taskTemplateNames.Overview) {
    <app-task-overview-template
      [element]="element"
      [columnName]="columnName"
    ></app-task-overview-template>
  }
  @case (taskTemplateNames.Log) {
    <app-task-log-template [element]="element" [columnName]="columnName"></app-task-log-template>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
